<ng-container *ngIf="dataServiceObj">
  <load-template htmlTemp="{{tname}}" [tData]="dataServiceObj" [redesign]="redesign"></load-template>
</ng-container>